import React, { ReactElement, useState } from 'react';
import { ZfFormField, ZfInput, ZfTextButton } from '@zafire/react';

type PcoStubNestedWCProps = {
  version: string;
  updateVersion?: (version: string) => void;
};

export const PcoStubNestedWC = ({ version, updateVersion }: PcoStubNestedWCProps): ReactElement => {
  const [newVersion, setNewVersion] = useState(version);
  const [prevVersion, setPrevVersion] = useState(version);
  if (version !== prevVersion) {
    setPrevVersion(version);
    setNewVersion(version);
  }

  return (
    <div style={{ padding: '16px', fontFamily: 'sans-serif', border: '2px dashed teal' }}>
      <h3>PCO stub loaded from NESTED remote</h3>
      <p>version: {version}</p>
      <ZfFormField label="version">
        <ZfInput
          data-testid="version-input"
          value={newVersion}
          onInputChange={(e) => setNewVersion(e.detail)}
          style={{ width: 'fit-content' }}
        />
      </ZfFormField>
      <ZfTextButton
        data-testid="send-postmessage-button"
        hierarchy="primary"
        onClick={() => updateVersion?.(newVersion)}
        style={{ width: 'fit-content' }}
      >
        Send postMessage
      </ZfTextButton>
    </div>
  );
};
